/* ============================================================
   EY buy-box v7 — stepper ilości + CTA z realnym rabatem + upsell + dodatki.
   (brief 2026-07-14 v6; v7 2026-09-10 — dodatki z konfiguratora)

   Mechanika:
   - Stepper [− n +] steruje ilością (qty, min 1, bez górnego limitu).
   - Tryb 'fotel': total = n×unit − floor(n/2)×round(unit×pct/100).
     pct = rabat na co drugą sztukę z metafielda (custom.rabat_druga_sztuka_pct),
     wpisany do JSON produktu. Rabat nalicza automat BXGY w koszyku — CTA pokazuje
     dokładnie tę kwotę (per-item round, zgodne z BXGY „buy 1 get 1 −pct%").
   - Karta ‚weź 2 sztuki" (type=quantity) = shortcut: klik ustawia qty na target
     (toggle: klik gdy już na target → wróć do 1). Podświetla się, gdy qty===target
     w trybie fotel. qty poza target → gaśnie, ale rabat dalej liczony w cenie.
   - Karta „pufa" (type=product) = tryb 'komplet': stepper liczy komplety,
     CTA „Dodaj komplet · cena×qty". Klik w zaznaczoną → powrót do fotel/qty 1.
   - DODATKI (v7): konfigurator wystawia na swoim korzeniu eyExtras() ->
     [{id, qty, price}]. Buy-box dolicza je do ceny na CTA i dokłada jako osobne
     pozycje przy dodaniu do koszyka. Konfigurator NIGDY nie dodaje nic sam —
     jedna ścieżka koszyka i jedna cena, więc podsumowanie i przycisk nie mogą
     się rozjechać.

   - WYSYŁKA (v3, 10.2026): kwota z tabeli snippets/ey-ship-tiers.liquid dla
     wagi wyboru (wariant × ilość + pufa w komplecie + dodatki). Od 13.10.2026
     BEZ wagi koszyka: całe zamówienie liczy koszyk. Ta sama tabela co kasa.

   Submit: fotel → wariant fotela × qty; komplet → wariant zestawu (match kolor) × qty;
   cokolwiek z dodatkami → wieloelementowy /cart/add.js.

   Wzorce: init na DOMContentLoaded + shopify:section:load, rejestr instancji per
   section (re-init w edytorze bez duplikacji listenerów).
   GOTCHA: form.id przesłonięte przez input[name="id"] → getAttribute.
   ============================================================ */
(function () {
  'use strict';

  var MONTHS_GEN = [
    'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
    'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
  ];

  var numberFormat = null;
  function moneyBare(cents) {
    if (numberFormat === null) {
      try {
        /* ZAWSZE dwa miejsca po przecinku. Wczesniej grosze pojawialy sie
           tylko wtedy, gdy byly realne, przez co karta mieszala dwa formaty:
           „240,00 zl" w bloku ceny u gory i „240 zl" na kaflach, przycisku
           i w podsumowaniu. Przy skanowaniu wzrokiem wyglada to jak dwie
           rozne wartosci, a nie ta sama. */
        numberFormat = new Intl.NumberFormat('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        numberFormat = false;
      }
    }
    var amount = cents / 100;
    if (!numberFormat) {
      return amount.toFixed(2).replace('.', ',');
    }
    return numberFormat.format(amount);
  }
  function money(cents) {
    return moneyBare(cents) + ' zł';
  }
  /* Jeden format w calej kolumnie, takze dla oszczednosci */
  function saveText(cents) {
    return money(cents);
  }
  function saveSigned(cents) {
    return '−' + saveText(cents);
  }

  /* Rabat na co drugą sztukę: cena n sztuk i oszczędność (per-item round = zgodne z BXGY). */
  function unitDiscount(unit, pct) {
    return Math.round(unit * pct / 100);
  }
  function totalFotel(unit, pct, n) {
    return n * unit - Math.floor(n / 2) * unitDiscount(unit, pct);
  }
  function saveFotel(unit, pct, n) {
    return Math.floor(n / 2) * unitDiscount(unit, pct);
  }

  /* EY-SHIP-START
     Wysyłka v3: tabela z snippets/ey-ship-tiers.liquid ("maxGram:grosze", '*' = bez
     górnej granicy). Ta sama tabela co stawki w kasie, więc karta liczy dokładnie to,
     co policzy kasa za ten wybór (waga w gramach = wybór na karcie, bez koszyka).
     Test zgodności z kasą: wysylka3/skrypty/test_motyw.js (każdy gram 0..30000). */
  function parseShipTiers(s) {
    return String(s || '').split(',').map(function (t) {
      var p = t.split(':');
      return { max: p[0] === '*' ? Infinity : parseInt(p[0], 10), price: parseInt(p[1], 10) };
    }).filter(function (t) { return !isNaN(t.price) && (t.max === Infinity || !isNaN(t.max)); });
  }
  function shipTierPrice(tiers, grams) {
    var g = Math.round(grams);
    if (!(g > 0)) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (g <= tiers[i].max) return tiers[i].price;
    }
    return null;
  }
  /* Zwraca { kurier: grosze|null, inpost: grosze|null } dla wagi w gramach. */
  function shipQuote(kTiers, pTiers, grams) {
    return { kurier: shipTierPrice(kTiers, grams), inpost: shipTierPrice(pTiers, grams) };
  }
  /* EY-SHIP-END */

  /* Rejestr aktywnych instancji per section id (nadpisywany przy re-init) */
  var instances = {};

  /* ---------- Stepper + tryby + CTA ---------- */
  function initBuybox(ctaEl) {
    if (ctaEl.dataset.eyInit) return;
    ctaEl.dataset.eyInit = '1';

    var dataEl = ctaEl.querySelector('[data-ey-product-data]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var sectionId = ctaEl.dataset.sectionId;
    var formId = ctaEl.dataset.formId;
    var baseLabel = ctaEl.dataset.baseLabel || 'Dodaj do koszyka';
    var stickyLabel = ctaEl.dataset.stickyLabel || 'Dodaj';
    var qtyLabelBase = ctaEl.dataset.qtyLabel || 'Ilość';
    var qtyLabelBundle = ctaEl.dataset.bundleQtyLabel || 'Ilość kompletów';
    var hintTpl = ctaEl.dataset.saveHint || 'Oszczędzasz {save} — co druga sztuka −{pct}%.';

    var variantsById = {};
    data.variants.forEach(function (v) { variantsById[String(v.id)] = v; });

    var state = {
      qty: 1,
      mode: 'fotel', // 'fotel' | 'komplet'
      pct: parseInt(data.pct, 10) || 0,
      fotel: variantsById[String(data.currentId)] || data.variants[0] || null
    };

    // referencje nowego sticky bara (budowane w initSticky)
    var stickyBar = null, stickyThumb = null, stickyName = null, stickyPrice = null, stickyCtaBtn = null;

    function form() { return document.getElementById(formId); }
    function idInput() {
      var f = form();
      return f ? f.querySelector('input[name="id"]') : null;
    }
    function qtyInput() {
      var f = form();
      if (!f) return null;
      var q = f.querySelector('[data-ey-qty]') || f.querySelector('input[name="quantity"]');
      if (!q) {
        q = document.createElement('input');
        q.type = 'hidden';
        q.name = 'quantity';
        q.value = '1';
        q.setAttribute('data-ey-qty', '');
        f.appendChild(q);
      }
      return q;
    }
    function options() {
      return [].slice.call(document.querySelectorAll('[data-ey-up][data-section-id="' + sectionId + '"]'));
    }
    function pufaOption() {
      var opts = options();
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].dataset.type === 'product') return opts[i];
      }
      return null;
    }
    function optionBundleData(opt) {
      var el = opt.querySelector('[data-ey-up-data]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    /* Wariant pufy dla koloru bieżącego fotela. Match po WARTOŚCI koloru
       (pufa może mieć opcję „Color" zamiast „Kolor" — porównujemy wartości). */
    function bundleVariant(opt) {
      var bd = optionBundleData(opt);
      if (!bd || !state.fotel) return null;
      for (var i = 0; i < bd.variants.length; i++) {
        var v = bd.variants[i];
        var colors = v.colors || (v.color ? [v.color] : []);
        if (v.available && colors.indexOf(state.fotel.color) !== -1) return v;
      }
      return null;
    }

    /* ---------- Dodatki z konfiguratora (v7) ----------
       assets/ey-configurator.js ustawia na swoim korzeniu funkcję eyExtras().
       Gdy konfiguratora nie ma na stronie, lista jest pusta i wszystko poniżej
       zachowuje się dokładnie jak w v6. */
    function extrasHost() {
      return document.querySelector('[data-ey-cfg][data-section-id="' + sectionId + '"]');
    }
    function extras() {
      var host = extrasHost();
      if (!host || typeof host.eyExtras !== 'function') return [];
      try { return host.eyExtras() || []; } catch (e) { return []; }
    }
    function extrasUnit() {
      return extras().reduce(function (sum, x) {
        return sum + (parseInt(x.price, 10) || 0) * (parseInt(x.qty, 10) || 1);
      }, 0);
    }
    function extrasTotal() {
      return extrasUnit() * state.qty;
    }

    /* ---------- Wysyłka (v3) ----------
       Tabele przychodzą z data-ship-tiers (kurier) i data-ship-tiers-inpost,
       ustawionych w snippets/ey-buybox-cta.liquid z snippets/ey-ship-tiers.liquid.
       JEDNO źródło dla SSR, JS i kasy. */
    var shipK = parseShipTiers(ctaEl.dataset.shipTiers);
    var shipP = parseShipTiers(ctaEl.dataset.shipTiersInpost);
    var shipFallback = ctaEl.dataset.shipFallback || '';

    /* Waga tego, co JUŻ jest w koszyku (gramy). Start z SSR (cart.total_weight),
       potem /cart.js po każdej zmianie koszyka. Licznik żądań: odpowiedź na
       starsze żądanie nie może nadpisać nowszej (updateCtaAndSticky jest
       synchroniczne, a fetch nie). */
    var cartGrams = parseInt(ctaEl.dataset.shipCartG, 10) || 0;
    var cartReq = 0;
    function refreshCartWeight() {
      if (!window.fetch) return;
      var my = ++cartReq;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (my !== cartReq || !c) return;
          cartGrams = Math.round(parseFloat(c.total_weight) || 0);
          updateShipping();
        })
        .catch(function () { /* zostaje ostatnia znana waga koszyka */ });
    }

    /* DODATKI LICZA SIE DO WAGI. Wczesniej brana byla tylko waga glownego
       wariantu (plus komplet), wiec dolozenie lezanki za 520 zl nie ruszalo
       kwoty „Wysylka 20 zl", choc paczka rosla kilkukrotnie. Klient widzial
       jedna kwote na karcie, a inna w kasie. Wagi dodatkow przychodza z wyspy
       konfiguratora jako `w` w gramach. */
    function cartWeightGrams() {
      if (!state.fotel) return 0;
      var unit = parseInt(state.fotel.weight, 10) || 0;
      if (isKomplet()) {
        var pv = bundleVariant(pufaOption());
        if (pv) unit += parseInt(pv.weight, 10) || 0;
      }
      extras().forEach(function (x) {
        unit += (parseInt(x.w, 10) || 0) * (parseInt(x.qty, 10) || 1);
      });
      return unit * state.qty;
    }

    /* Tekst kosztu dla wyboru na karcie (grams) plus koszyk.
       - sama drobnica: „od 10,99 zł (paczkomat)" (paczkomat najtańszy);
       - z meblem: kwota kuriera;
       - koszyk NIE wchodzi do kwoty (13.10.2026, Marcel): karta pokazuje koszt
         wysyłki tylko tego, co klient konfiguruje. Całe zamówienie liczy koszyk. */
    function shipLabel(grams) {
      // Brak wagi wariantu → nie zgadujemy: statyczny metafield albo nic.
      if (!grams) return shipFallback;
      var q = shipQuote(shipK, shipP, grams); /* 13.10.2026: bez wagi koszyka, tylko ta karta */
      if (q.kurier === null) return shipFallback;
      var txt = money(q.kurier);
      if (q.inpost !== null && q.inpost < q.kurier) txt = 'od ' + money(q.inpost) + ' (paczkomat)';
      return txt;
    }

    function updateShipping() {
      var el = ctaEl.querySelector('[data-ey-ship]');
      if (!el) return;
      var txt = shipLabel(cartWeightGrams());
      el.textContent = txt;
      var wrap = ctaEl.querySelector('[data-ey-ship-wrap]');
      if (wrap) wrap.hidden = txt === '';
    }

    function kompletPrice(opt) {
      return opt ? (parseInt(opt.dataset.kompletPrice, 10) || 0) : 0;
    }

    /* Ustaw wariant + ilość w formularzu. W trybie komplet formularz trzyma
       fotel (fallback), a właściwe dodanie pozycji robi addMulti() przy submit. */
    function applyToForm() {
      var input = idInput();
      if (!input) return;
      var q = qtyInput();
      if (state.mode === 'komplet') {
        var pufa = pufaOption();
        if (!(pufa && bundleVariant(pufa))) state.mode = 'fotel'; // brak pufy → fotel
      }
      if (state.fotel) input.value = state.fotel.id;
      if (q) q.value = String(state.qty);
    }

    /* Tryb komplet aktywny i pufa dostępna dla koloru? */
    function isKomplet() {
      if (state.mode !== 'komplet') return false;
      var pufa = pufaOption();
      return !!(pufa && bundleVariant(pufa));
    }

    /* Czy submit musi pójść wieloelementowym /cart/add.js zamiast zwykłego add? */
    function needsMultiAdd() {
      return isKomplet() || extras().length > 0;
    }

    /* Dodaj wszystko jako osobne pozycje koszyka (rabaty naliczą automaty).
       Wzorzec Dawn: sekcje do renderu + renderContents na elemencie koszyka. */
    function addMulti() {
      if (!state.fotel) return false;
      var items = [{ id: state.fotel.id, quantity: state.qty }];

      if (isKomplet()) {
        var pv = bundleVariant(pufaOption());
        if (!pv) return false;
        items.push({ id: pv.id, quantity: state.qty });
      }
      extras().forEach(function (x) {
        var q = (parseInt(x.qty, 10) || 1) * state.qty;
        if (x.id && q > 0) items.push({ id: x.id, quantity: q });
      });
      if (items.length < 2) return false;

      var submitBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      var spinner = submitBtn ? submitBtn.querySelector('.loading__spinner') : null;
      if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartEl && cartEl.getSectionsToRender) {
        body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement);
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (resp) {
        if (resp && resp.status) { console.error('EY multi add error:', resp.description || resp.message); return; }
        if (cartEl && cartEl.renderContents) { cartEl.renderContents(resp); }
        else { window.location = (window.routes && window.routes.cart_url) || '/cart'; }
      }).catch(function (e) { console.error(e); }).finally(function () {
        if (submitBtn) { submitBtn.classList.remove('loading'); submitBtn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
        if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
      });
      return true;
    }

    /* Cena + etykieta + nazwa (sticky) dla aktualnego stanu */
    function selectionInfo() {
      var f = state.fotel;
      if (!f) return null;
      var ex = extrasTotal();
      if (state.mode === 'komplet') {
        var pufa = pufaOption();
        var pv = pufa ? bundleVariant(pufa) : null;
        if (!pv) return null;
        var kp = kompletPrice(pufa);
        var unitKomplet = f.price + kp;        // komplet za 1 szt. (fotel + 199)
        var capKomplet = f.price + pv.price;   // bez rabatu podnóżka
        var name = pufa.dataset.stickyName || data.title;
        var kCap = state.qty === 1 && capKomplet > unitKomplet ? capKomplet + ex : 0;
        return {
          label: pufa.dataset.ctaLabel || baseLabel,
          price: unitKomplet * state.qty + ex,
          cap: kCap,
          stickyName: (state.qty > 1 ? state.qty + '× ' : '') + name,
          hint: null
        };
      }
      var total = totalFotel(f.price, state.pct, state.qty);
      var hint = null;
      if (state.qty >= 2 && state.pct > 0) {
        hint = hintTpl
          .replace('{save}', saveText(saveFotel(f.price, state.pct, state.qty)))
          .replace('{pct}', state.pct);
      }
      return {
        label: baseLabel,
        price: total + ex,
        cap: state.qty === 1 && f.cap > f.price ? f.cap + ex : 0,
        stickyName: (state.qty > 1 ? state.qty + '× ' : '') + data.title,
        hint: hint
      };
    }

    function updateCtaAndSticky() {
      var sel = selectionInfo();
      if (!sel) return;

      var labelEl = ctaEl.querySelector('[data-ey-cta-label]');
      if (labelEl) labelEl.textContent = sel.label;
      var nowEl = ctaEl.querySelector('[data-ey-cta-now]');
      if (nowEl) nowEl.textContent = '· ' + money(sel.price);
      var wasEl = ctaEl.querySelector('[data-ey-cta-was]');
      if (wasEl) {
        if (sel.cap > 0) {
          wasEl.textContent = moneyBare(sel.cap);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

      // stepper: label + wartość + minus disabled
      var qvEl = ctaEl.querySelector('[data-ey-qv]');
      if (qvEl) qvEl.textContent = state.qty;
      var qLabelEl = ctaEl.querySelector('[data-ey-qty-label]');
      if (qLabelEl) qLabelEl.textContent = state.mode === 'komplet' ? qtyLabelBundle : qtyLabelBase;
      var minusBtn = ctaEl.querySelector('[data-ey-step="-1"]');
      if (minusBtn) minusBtn.disabled = state.qty <= 1;

      // komunikat oszczędności
      var hintEl = ctaEl.querySelector('[data-ey-hint]');
      if (hintEl) {
        if (sel.hint) {
          hintEl.textContent = sel.hint;
          hintEl.hidden = false;
        } else {
          hintEl.hidden = true;
        }
      }

      updateShipping();
      updateSticky();
    }

    /* Podświetlenie kart wg stanu */
    function renderSelection() {
      options().forEach(function (o) {
        var on = false;
        if (o.dataset.type === 'product') {
          on = state.mode === 'komplet';
        } else {
          var target = parseInt(o.dataset.target, 10) || 2;
          on = state.mode === 'fotel' && state.qty === target;
        }
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* Przelicz ceny na kartach opcji (po zmianie wariantu/koloru) */
    function renderOptions() {
      var f = state.fotel;
      if (!f) return;
      options().forEach(function (opt) {
        var was = opt.querySelector('[data-ey-up-was]');
        var now = opt.querySelector('[data-ey-up-now]');
        var save = opt.querySelector('[data-ey-up-save]');
        if (opt.dataset.type === 'product') {
          var pv = bundleVariant(opt);
          if (!pv) {
            opt.hidden = true;
            if (state.mode === 'komplet') { state.mode = 'fotel'; state.qty = 1; }
            return;
          }
          opt.hidden = false;
          var kp = kompletPrice(opt);
          var kNow = f.price + kp;             // fotel + 199
          var kWas = f.price + pv.price;       // fotel + pełna pufa
          var kSave = pv.price - kp;           // oszczędność na pufie
          if (kSave < 0) kSave = 0;
          if (now) now.textContent = money(kNow);
          if (was) {
            if (kWas > kNow) { was.textContent = moneyBare(kWas); was.hidden = false; } else { was.hidden = true; }
          }
          if (save) {
            if (kSave > 0) { save.textContent = saveSigned(kSave); save.hidden = false; } else { save.hidden = true; }
          }
        } else {
          var target = parseInt(opt.dataset.target, 10) || 2;
          var pct = parseInt(opt.dataset.discount, 10) || 0;
          var full = f.price * target;
          var qSave = saveFotel(f.price, pct, target);
          if (now) now.textContent = money(full - qSave);
          if (was) {
            if (qSave > 0) { was.textContent = moneyBare(full); was.hidden = false; } else { was.hidden = true; }
          }
          if (save) {
            if (qSave > 0) { save.textContent = saveSigned(qSave); save.hidden = false; } else { save.hidden = true; }
          }
        }
      });
    }

    function announce() {
      try {
        document.dispatchEvent(new CustomEvent('ey:buybox:render', { detail: { sectionId: sectionId } }));
      } catch (e) { /* starsze przeglądarki: podsumowanie policzy sie samo */ }
    }

    function renderAll() {
      renderOptions();
      renderSelection();
      updateCtaAndSticky();
      applyToForm();
      /* Konfigurator maluje podsumowanie DOPIERO po nas, tą samą kwotą. */
      announce();
    }

    /* ----- akcje ----- */
    function step(delta) {
      var next = state.qty + delta;
      if (next < 1) next = 1;
      state.qty = next;
      renderSelection();
      updateCtaAndSticky();
      applyToForm();
      announce();
    }

    function togglePick(opt) {
      if (!opt) return;
      if (opt.dataset.type === 'product') {
        // pufa: przełącz tryb komplet
        if (state.mode === 'komplet') {
          state.mode = 'fotel';
          state.qty = 1;
        } else {
          state.mode = 'komplet';
          state.qty = 1;
        }
      } else {
        // „2 sztuki": shortcut na target (toggle z 1)
        var target = parseInt(opt.dataset.target, 10) || 2;
        state.mode = 'fotel';
        state.qty = state.qty === target ? 1 : target;
      }
      renderSelection();
      updateCtaAndSticky();
      applyToForm();
      announce();
    }

    function onVariantIdChange(value) {
      var v = variantsById[String(value)];
      if (v) {
        state.fotel = v;
        renderAll();
      } else {
        // wartość spoza produktu (nasz zapis zestawu) — utrzymaj stan
        applyToForm();
      }
    }

    /* ---------- Sticky bar mobile (brief 2026-07-14) ----------
       Widoczny WYŁĄCZNIE gdy główne CTA przewinięte poza GÓRNĄ krawędź viewportu. */
    function initSticky() {
      var legacy = document.getElementById('EcoStickyCta-' + sectionId);
      if (!legacy) return; // sticky wyłączony w ustawieniach sekcji
      var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!mainBtn) return;

      // re-init w edytorze: usuń poprzednią instancję, zbuduj świeżą
      var prev = document.querySelector('.ey-sticky[data-ey-sticky="' + sectionId + '"]');
      if (prev) prev.remove();

      stickyBar = document.createElement('div');
      stickyBar.className = 'ey-sticky';
      stickyBar.setAttribute('data-ey-sticky', sectionId);
      stickyBar.setAttribute('aria-hidden', 'true');

      stickyThumb = document.createElement('img');
      stickyThumb.className = 'ey-sticky__thumb';
      stickyThumb.alt = '';
      stickyThumb.setAttribute('loading', 'lazy');
      stickyThumb.setAttribute('width', '42');
      stickyThumb.setAttribute('height', '42');

      var mid = document.createElement('div');
      mid.className = 'ey-sticky__mid';
      stickyName = document.createElement('div');
      stickyName.className = 'ey-sticky__name';
      stickyPrice = document.createElement('div');
      stickyPrice.className = 'ey-sticky__price';
      mid.appendChild(stickyName);
      mid.appendChild(stickyPrice);

      stickyCtaBtn = document.createElement('button');
      stickyCtaBtn.type = 'button';
      stickyCtaBtn.className = 'ey-sticky__cta';
      stickyCtaBtn.textContent = stickyLabel;
      stickyCtaBtn.addEventListener('click', function () {
        // klik = submit bieżącej konfiguracji (komplet / dodatki / wariant / ilość)
        if (!mainBtn.disabled) mainBtn.click();
      });

      stickyBar.appendChild(stickyThumb);
      stickyBar.appendChild(mid);
      stickyBar.appendChild(stickyCtaBtn);
      document.body.appendChild(stickyBar);

      // stan disabled lustrzany do głównego przycisku
      stickyCtaBtn.disabled = mainBtn.disabled;
      new MutationObserver(function () {
        stickyCtaBtn.disabled = mainBtn.disabled;
      }).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

      /* KIEDY POKAZUJEMY PIGUŁKĘ.
         Poprzednia wersja pokazywała ją TYLKO wtedy, gdy przycisk był już nad
         górną krawędzią, czyli dopiero PO minięciu celu. Klient schodzący przez
         konfigurator nie widział żadnego CTA przez około dwa ekrany na
         desktopie i cztery na telefonie, a to jest dokładnie ten odcinek drogi,
         na którym się gubi. Teraz pigułka wychodzi też wtedy, gdy przycisk jest
         jeszcze PRZED nim, pod warunkiem że zszedł poniżej progu. Sam początek
         strony zostaje czysty, bo tam cena i tak jest widoczna.
         Test Growth Rock na sklepie z suplementami (2-3 tys. konwersji na
         wariant): sticky na desktopie +7,9% zamówień, wysuwany pasek na mobile
         +5,2%, a wariant, który tylko przewijał do przycisku, nie dał nic. */
      var startAnchor = document.querySelector('.ey-cfg--lead, .ey-cfg--sec');

      function startOffset() {
        var anchorY = startAnchor
          ? startAnchor.getBoundingClientRect().top + window.scrollY
          : 0;
        return Math.max(anchorY, window.innerHeight * 0.5);
      }

      /* Na desktopie pigułka równa się prawą krawędzią z kolumną zakupową,
         inaczej wisiałaby nad galerią albo na środku pustego ekranu. */
      function placeSticky() {
        if (window.innerWidth < 750) {
          stickyBar.style.left = '';
          stickyBar.style.width = '';
          return;
        }
        var host = document.querySelector('.product__info-container') || ctaEl;
        var b = host.getBoundingClientRect();
        var w = Math.min(Math.round(b.width), 540);
        stickyBar.style.left = Math.round(b.left + b.width - w) + 'px';
        stickyBar.style.width = w + 'px';
      }

      var stickyShown = null;
      function syncSticky() {
        var r = mainBtn.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight;
        var show = !inView && window.scrollY > startOffset();
        if (show === stickyShown) return;
        stickyShown = show;
        if (show) placeSticky();
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
      }

      /* Dławik czasowy zamiast requestAnimationFrame: rAF nie odpala się na
         karcie w tle ani przy zdarzeniach syntetycznych, więc stan pigułki
         potrafił zostać zamrożony. Dwa odczyty geometrii co 60 ms nic nie
         kosztują, a zachowanie jest przewidywalne w każdym kontekście. */
      var lastStickySync = 0;
      function onStickyScroll() {
        var now = Date.now();
        if (now - lastStickySync < 60) return;
        lastStickySync = now;
        syncSticky();
      }
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      window.addEventListener('resize', function () {
        stickyShown = null;
        placeSticky();
        onStickyScroll();
      }, { passive: true });

      placeSticky();
      syncSticky();
      updateSticky();
    }

    /* Aktualizacja treści sticky (cena/nazwa/miniatura) wg bieżącego stanu */
    function updateSticky() {
      if (!stickyBar) return;
      var sel = selectionInfo();
      if (sel && stickyPrice) stickyPrice.textContent = money(sel.price);
      if (stickyName) {
        var col = state.fotel && state.fotel.color ? state.fotel.color : '';
        stickyName.textContent = data.title + (col ? ' · ' + col : '');
      }
      if (stickyThumb && state.fotel && state.fotel.image && stickyThumb.getAttribute('src') !== state.fotel.image) {
        stickyThumb.src = state.fotel.image;
      }
    }

    instances[sectionId] = {
      formId: formId,
      step: step,
      togglePick: togglePick,
      onVariantIdChange: onVariantIdChange,
      applyToForm: applyToForm,
      isKomplet: isKomplet,
      needsMultiAdd: needsMultiAdd,
      addMulti: addMulti,
      refresh: renderAll,
      refreshCartWeight: refreshCartWeight,
      qty: function () { return state.qty; },
      total: function () { var s = selectionInfo(); return s ? s.price : 0; }
    };

    initSticky();
    renderAll();
    /* SSR zna koszyk z chwili renderu; jedno świeże odczytanie na starcie
       zamyka przypadek strony podanej z pamięci przeglądarki. */
    refreshCartWeight();
  }

  /* Publiczny uchwyt dla konfiguratora: jedna kwota, jedno źródło. */
  window.eyBuybox = window.eyBuybox || {
    get: function (sectionId) { return instances[sectionId] || null; }
  };

  /* ---------- Daty dostawy: dni robocze, strefa Warszawy, godzina odciecia ----------
     TRZY RZECZY, KTORE MUSZA SIE ZGADZAC, ZEBY DATA NIE SPIESZYLA:

     1. STREFA. Date liczymy w Europe/Warsaw, a nie w strefie przegladarki.
        Klient z Chicago ma o 7 godzin wczesniej i przy zamowieniu zlozonym
        u nas w srode rano jego przegladarka twierdzila, ze jest wtorek, wiec
        widzialby date o dzien wczesniejsza, niz mozemy dowiezc.
     2. GODZINA ODCIECIA. Zamowienie o 22:00 nie trafia do szwalni tego samego
        dnia. Po godzinie odciecia liczymy od nastepnego dnia roboczego.
     3. WEEKEND. W sobote i niedziele nikt nie szyje, wiec baza przesuwa sie
        na poniedzialek, zanim zaczniemy dodawac dni robocze.

     Model: „dzien startu" to pierwszy dzien roboczy, w ktorym zamowienie moze
     realnie ruszyc. Data dostawy = dzien startu + (szycie + kurier) dni
     roboczych. Blad zawsze w strone pozniejszej daty, nigdy wczesniejszej. */
  function warsawNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Warsaw',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var g = {};
      parts.forEach(function (p) { g[p.type] = p.value; });
      var h = parseInt(g.hour, 10);
      if (h === 24) h = 0;
      return new Date(parseInt(g.year, 10), parseInt(g.month, 10) - 1, parseInt(g.day, 10), h, parseInt(g.minute, 10));
    } catch (err) {
      return new Date();
    }
  }
  function isWeekend(d) { var x = d.getDay(); return x === 0 || x === 6; }
  function startDay(cutoffHour) {
    var d = warsawNow();
    var late = cutoffHour != null && !isNaN(cutoffHour) && d.getHours() >= cutoffHour;
    var move = late || isWeekend(d);
    d.setHours(0, 0, 0, 0);
    if (move) {
      do { d.setDate(d.getDate() + 1); } while (isWeekend(d));
    }
    return d;
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function formatDateRange(from, to) {
    if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
      if (from.getDate() === to.getDate()) {
        return from.getDate() + ' ' + MONTHS_GEN[from.getMonth()];
      }
      return from.getDate() + '–' + to.getDate() + ' ' + MONTHS_GEN[from.getMonth()];
    }
    return from.getDate() + ' ' + MONTHS_GEN[from.getMonth()] + ' – ' + to.getDate() + ' ' + MONTHS_GEN[to.getMonth()];
  }
  /* Dwa okna szycia. Domyslne (sew_min/sew_max) opisuje kolor, ktorego tkanine
     kompletujemy pod zamowienie; szybsze (sew_*_fast) - kolor z glownej palety.
     Konfigurator mowi zdarzeniem ey:cfg:color, ktore obowiazuje, wiec data na
     karcie nie klami, gdy klient przelaczy sie na kolor na zamowienie.
     Produkt bez konfiguratora nigdy nie dostaje tego zdarzenia i zostaje na
     oknie domyslnym, czyli na dotychczasowym zachowaniu. */
  function renderDelivery(el, fast) {
    var sMin, sMax;
    if (fast && el.dataset.sewMinFast != null) {
      sMin = parseInt(el.dataset.sewMinFast, 10) || 0;
      sMax = parseInt(el.dataset.sewMaxFast, 10) || 0;
    } else {
      sMin = parseInt(el.dataset.sewMin, 10) || 0;
      sMax = parseInt(el.dataset.sewMax, 10) || 0;
    }
    var minDays = sMin + (parseInt(el.dataset.courierMin, 10) || 0);
    var maxDays = sMax + (parseInt(el.dataset.courierMax, 10) || 0);
    var base = startDay(parseInt(el.dataset.cutoffHour, 10));
    var range = formatDateRange(addBusinessDays(base, minDays), addBusinessDays(base, maxDays));
    var target = el.querySelector('[data-ey-dates]');
    if (!target) return;
    var template = el.dataset.template || '{daty}';
    // template z settings (plain text) — jedyny HTML to nasze <b> wokół dat
    var parts = template.split('{daty}');
    target.textContent = '';
    target.appendChild(document.createTextNode(parts[0] || ''));
    var b = document.createElement('b');
    b.textContent = range;
    target.appendChild(b);
    target.appendChild(document.createTextNode(parts[1] || ''));
  }
  function initDelivery(el) {
    if (el.dataset.eyInit) return;
    el.dataset.eyInit = '1';
    renderDelivery(el, false);
  }

  /* ---------- Data dostawy w linii pod przyciskiem ----------
     KONKRETNA DATA, nie „3-6 dni roboczych". Baymard (41 procent sklepow podaje
     sama predkosc wysylki): badani zatrzymywali sie i otwierali kalendarz, zeby
     policzyc, kiedy przesylka u nich bedzie, a z tej samej opcji wyciagali rozne
     wnioski. https://baymard.com/blog/shipping-speed-vs-delivery-date

     Okna czytamy z USTAWIEN MOTYWU, ktore Liquid wypisuje na bloku CTA. Blok CTA
     istnieje na kazdej karcie produktu, wiec obietnica terminu nie znika, gdy
     ktos wylaczy osobny pasek dostawy. */
  function renderEta(cta, fast) {
    var wrap = cta.querySelector('[data-ey-eta-wrap]');
    var out = cta.querySelector('[data-ey-eta]');
    var sep = cta.querySelector('[data-ey-eta-sep]');
    if (!wrap || !out) return;
    var d = cta.dataset;
    var sMin = parseInt(fast ? d.sewFastMin : d.sewOrderMin, 10);
    var sMax = parseInt(fast ? d.sewFastMax : d.sewOrderMax, 10);
    var cMin = parseInt(d.courierMin, 10);
    var cMax = parseInt(d.courierMax, 10);
    if (isNaN(sMin) || isNaN(sMax) || isNaN(cMin) || isNaN(cMax)) { wrap.hidden = true; if (sep) sep.hidden = true; return; }
    var maxDays = sMax + cMax;
    if (maxDays <= 0) { wrap.hidden = true; if (sep) sep.hidden = true; return; }
    var base = startDay(parseInt(d.cutoffHour, 10));
    out.textContent = formatDateRange(addBusinessDays(base, sMin + cMin), addBusinessDays(base, maxDays));
    wrap.hidden = false;
    /* separator tylko wtedy, gdy po lewej naprawde cos stoi */
    var ship = cta.querySelector('[data-ey-ship-wrap]');
    if (sep) sep.hidden = !ship || ship.hidden;
  }

  /* ---------- Globalne listenery (raz na stronę) ---------- */
  function bindGlobal() {
    if (window.__eyBuyboxBound) return;
    window.__eyBuyboxBound = true;

    /* Wysyłka v3: każda zmiana koszyka (dodanie z karty, szuflada, upsell w
       szufladzie, usunięcie) zmienia wagę całego zamówienia, a więc i kwotę na
       karcie. Ten sam wzorzec co w snippets/ey-src.liquid: obserwujemy fetch na
       /cart/add|change|update|clear i po odpowiedzi odświeżamy wagę koszyka.
       Własne żądanie /cart.js nie pasuje do wzorca, więc nie ma pętli. */
    var SHIP_CART_RE = /\/cart\/(add|change|update|clear)/;
    var shipTimer = null;
    function refreshAllCartWeights() {
      clearTimeout(shipTimer);
      shipTimer = setTimeout(function () {
        Object.keys(instances).forEach(function (sid) {
          if (instances[sid].refreshCartWeight) instances[sid].refreshCartWeight();
        });
      }, 150);
    }
    if (window.fetch && !window.__eyShipFetchWrapped) {
      window.__eyShipFetchWrapped = true;
      var shipRawFetch = window.fetch;
      window.fetch = function (input) {
        var u = (typeof input === 'string') ? input : ((input && input.url) || '');
        var pr = shipRawFetch.apply(this, arguments);
        if (SHIP_CART_RE.test(u)) {
          pr.then(refreshAllCartWeights, function () {});
        }
        return pr;
      };
    }
    /* Powrót przyciskiem Wstecz (bfcache) albo z innej karty: koszyk mógł się zmienić. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAllCartWeights(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshAllCartWeights();
    });

    /* konfigurator zmienil kolor -> data dostawy idzie za nim */
    document.addEventListener('ey:cfg:color', function (e) {
      var fast = !(e.detail && e.detail.order);
      document.querySelectorAll('[data-ey-delivery]').forEach(function (el) {
        renderDelivery(el, fast);
      });
      document.querySelectorAll('[data-ey-cta]').forEach(function (el) {
        renderEta(el, fast);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // stepper
      var stepBtn = e.target.closest('[data-ey-step]');
      if (stepBtn) {
        var cta = stepBtn.closest('[data-ey-cta]');
        if (cta) {
          var inst = instances[cta.dataset.sectionId];
          if (inst) inst.step(parseInt(stepBtn.dataset.eyStep, 10) || 0);
        }
        return;
      }
      // karty upsell
      var opt = e.target.closest('[data-ey-up]');
      if (opt) {
        var inst2 = instances[opt.dataset.sectionId];
        if (inst2) inst2.togglePick(opt);
      }
    });

    // Dawn po zmianie wariantu ustawia input[name="id"] i dispatchuje change.
    // Uwaga: form.id jest przesłonięte przez input[name="id"] → getAttribute!
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.matches || !target.matches('input[name="id"]')) return;
      var pf = target.closest('form');
      if (!pf) return;
      var pfId = pf.getAttribute('id');
      Object.keys(instances).forEach(function (sid) {
        if (instances[sid].formId === pfId) instances[sid].onVariantIdChange(target.value);
      });
    });

    // Submit: komplet albo dodatki → przechwyć i dodaj wszystkie pozycje przez
    // /cart/add.js zamiast zwykłego add jednego wariantu; inaczej pas
    // bezpieczeństwa (wymuś wariant/ilość).
    // Capture + stopImmediatePropagation ubiega listener product-form (Dawn).
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var fId = f.getAttribute('id');
      Object.keys(instances).forEach(function (sid) {
        if (instances[sid].formId !== fId) return;
        if (instances[sid].needsMultiAdd()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          // Gdyby budowa koszyka się nie udała, NIE zostawiamy klienta z martwym
          // przyciskiem: wracamy do zwykłego wysłania formularza.
          if (!instances[sid].addMulti()) {
            instances[sid].applyToForm();
            HTMLFormElement.prototype.submit.call(f);
          }
        } else {
          instances[sid].applyToForm();
        }
      });
    }, true);
  }

  function initAll(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-ey-cta]').forEach(initBuybox);
    root.querySelectorAll('[data-ey-delivery]').forEach(initDelivery);
    /* Domyslnie okno DLUZSZE. Produkt bez konfiguratora nigdy nie dostanie
       zdarzenia ey:cfg:color, wiec lepiej, zeby zostal na ostrozniejszej
       obietnicy. Na karcie z konfiguratorem poprawi to pierwszy paint. */
    root.querySelectorAll('[data-ey-cta]').forEach(function (el) { renderEta(el, false); });
  }

  bindGlobal();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
